// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M7.8,5.8c0.5,0,1.1,0,1.6,0.2c0.4,0.1,0.9,0.3,1.2,0.5C11,6.6,11.3,7,11.5,7.3c0.2,0.5,0.3,1,0.3,1.4c0,0.5-0.1,1.1-0.4,1.5
	c-0.3,0.4-0.8,0.8-1.3,1c0.7,0.2,1.3,0.6,1.7,1.1c0.4,0.6,0.6,1.3,0.6,2c0,0.5-0.1,1.1-0.3,1.6c-0.2,0.4-0.6,0.8-1,1.1
	c-0.4,0.3-0.9,0.5-1.4,0.6C9.1,18,8.5,18,8,18H2V5.8H7.8z M7.5,10.8c0.4,0,0.8-0.1,1.2-0.4C9,10.1,9.2,9.7,9.1,9.3
	c0-0.3,0-0.5-0.1-0.8C8.9,8.4,8.8,8.2,8.6,8.1C8.4,8,8.2,7.9,8,7.9c-0.2,0-0.5-0.1-0.7-0.1H4.7v2.9L7.5,10.8z M7.6,16
	c0.3,0,0.5,0,0.8-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.3,0.2-0.5,0.2-0.8c0-0.5-0.2-1-0.5-1.3
	c-0.4-0.3-0.9-0.4-1.4-0.4H4.7V16L7.6,16z M16.2,15.9c0.4,0.4,1,0.6,1.6,0.5c0.4,0,0.9-0.1,1.3-0.4c0.3-0.2,0.5-0.5,0.6-0.8h2.1
	c-0.2,0.9-0.8,1.7-1.6,2.3c-0.8,0.5-1.7,0.7-2.6,0.7c-0.6,0-1.3-0.1-1.9-0.3c-1.1-0.4-2-1.3-2.3-2.4c-0.2-0.6-0.3-1.2-0.3-1.9
	c0-0.6,0.1-1.3,0.3-1.9c0.2-0.6,0.5-1.1,0.9-1.5c0.4-0.4,0.9-0.8,1.4-1C16.4,9,17,8.9,17.6,8.9c0.7,0,1.4,0.1,2,0.4
	c0.5,0.3,1,0.7,1.4,1.2c0.4,0.5,0.6,1.1,0.8,1.7c0.2,0.7,0.2,1.3,0.2,2h-6.4C15.6,14.8,15.8,15.4,16.2,15.9z M19,11.2
	c-0.4-0.3-0.9-0.5-1.4-0.5c-0.3,0-0.7,0-1,0.2c-0.2,0.1-0.5,0.3-0.6,0.5c-0.2,0.2-0.3,0.4-0.3,0.6c-0.1,0.2-0.1,0.4-0.1,0.6h4
	C19.5,12.1,19.3,11.6,19,11.2z M15.1,6.6h5v1.2h-5V6.6z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-behance-Bw2eUGN3.js.map
